import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { t } from '../i18n'

/**
 * s69 / 2s (Marcelo 29/10/2026 10:30, "quando for excluir alguma coisa fazer sempre comando duplo"): toda exclusao pede
 * confirmacao. O botao de confirmar repete o verbo ("Excluir"), em vermelho; Cancelar e o padrao (Esc fecha sem excluir).
 */
export interface Confirmacao {
  mensagem: string
  acao: () => void
}

export function ConfirmDialog({ pedido, fechar }: { pedido: Confirmacao | null; fechar: () => void }) {
  return (
    <Dialog open={pedido !== null} onClose={fechar} aria-labelledby="confirmar-titulo" data-testid="confirmar-exclusao">
      <DialogTitle id="confirmar-titulo">{t.common.confirmDeleteTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>{pedido?.mensagem}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={fechar} autoFocus>
          {t.common.confirmDeleteNo}
        </Button>
        <Button
          color="error"
          variant="contained"
          data-testid="confirmar-exclusao-sim"
          onClick={() => {
            const a = pedido?.acao
            fechar()
            a?.()
          }}
        >
          {t.common.confirmDeleteYes}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
